import { Collapse } from "@mui/material";
import Typography from "@mui/material/Typography";
import { FC } from "react";
import { useLocation } from "react-router-dom";
import { USERS_PATH, CONTENT_SCHEDULE_PATH } from "shared/routes/paths";
import { COLOR_WHITE } from "shared/theme/colors";
import {
  StyledNavItemIconContainer,
  StyledNavItemTypography,
} from "../../styled";
import { StyledBox, StyledChip, StyledNavItemLink } from "./styled";

type Props = {
  pathname: string;
  Icon?: FC;
  title?: string;
  unreadCount?: number;
  isExpanded?: boolean;
};

export const NavItemLink: FC<Props> = ({
  pathname,
  title,
  Icon,
  unreadCount,
  isExpanded,
}) => {
  const location = useLocation();
  const currentPath = location.pathname;

  const active = currentPath.startsWith(pathname);
  const isUsersPath = pathname === USERS_PATH;
  const isContentSchedulePath = pathname === CONTENT_SCHEDULE_PATH;
  const iconColor = isUsersPath || isContentSchedulePath ? "transparent" : "";

  return (
    <StyledNavItemLink
      to={pathname}
      active={active}
      iconColor={iconColor}
      expanded={isExpanded}
    >
      <StyledBox>
        {Icon && (
          <StyledNavItemIconContainer
            expanded={isExpanded}
            active={active}
            iconColor={iconColor}
          >
            <Icon />
          </StyledNavItemIconContainer>
        )}
        <Collapse
          in={isExpanded}
          timeout="auto"
          unmountOnExit
          orientation="horizontal"
        >
          <StyledNavItemTypography active={active} variant="bodyLMedium">
            {title}
          </StyledNavItemTypography>
        </Collapse>
      </StyledBox>
      {isExpanded && unreadCount ? (
        <StyledChip px={unreadCount > 9 ? "3px" : ""}>
          <Typography variant="bodySSemiBold" color={COLOR_WHITE}>
            {unreadCount}
          </Typography>
        </StyledChip>
      ) : null}
    </StyledNavItemLink>
  );
};
